import PricesPage from "../components/pages/prices/PricesPage";

const routes = [
    {
        path: "/prices",
        element: <PricesPage />
    }
];

export default routes;
